export default __webpack_public_path__ + "images/badge-app-store.png";